import { localStoreStepName, localStoreFormDataName, localStoreSelectedCoffeeName } from '@/models/local-store';

const storage = sessionStorage;

export const resetAllStore = () => {
  storage.removeItem(localStoreStepName);
  storage.removeItem(localStoreFormDataName);
  storage.removeItem(localStoreSelectedCoffeeName);
};

export const resetStore = (store: string) => {
  storage.removeItem(store);
};

export const setToStore = (input: any, store: string) => {
  let data = input;
  if (typeof data === 'object') data = JSON.stringify(data);
  storage.setItem(store, data);
};

export const getFromStore = (store: string): any => {
  let data = storage.getItem(store);
  if (data) {
    try {
      data = JSON.parse(data);
    } catch (err) {
      // console.warn('Error parse from storage', err);
    }
  }
  return data;
};